//imports
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { clientQuery, clientMutation } from 'Core/data/GraphQLApi';
import { ExceptionManager } from 'Core/logManager';
import { endpoints } from 'Core/defaultValues';
import moment from 'moment';

//Action types
import {
    GENERAL_SEARCH_TAGS_REQUEST,
    GENERAL_SEARCH_MANUFACTURERS_REQUEST,
    GENERAL_SEARCH_SIM_PROVIDER_ACCOUNTS_REQUEST,
    GENERAL_SEARCH_SIM_PROVIDERS_REQUEST,
    GENERAL_SEARCH_DEVICE_MODELS_REQUEST,
    GENERAL_SEARCH_ENTITY_REQUEST,
    GENERAL_SEARCH_DEALERS_REQUEST,
    GENERAL_SEARCH_TIMEZONES_REQUEST,
    GENERAL_SAVE_AUDIT_LOG,
    GENERAL_GENERIC_EXPORT_SEND,
    GENERAL_COUNT_PEDING_NOTIFICATIONS,
    GENERAL_SEARCH_NOTIFICATIONS,
    GENERAL_UPDATE_NOTIFICATION,
    GENERAL_SAVE_PREFERENCE,
    GENERAL_GET_PREFERENCE,
    GENERAL_CATALOG_INITIAL,
    GENERAL_DOWNLOAD_REPORT_FILE_REQUEST
} from 'Redux/actionTypes';

//Actions
import {
    searchTagsResult,
    searchEntityResult,
    searchDeviceModelsResult,
    searchSimProvidersResult,
    searchSimProviderAccountsResult,
    searchManufacturersResult,
    searchDealersResult,
    searchTimeZonesResult,
    saveAuditLogResult,
    genericExportResult,
    searchCountNotificationsRequestResult,
    searchNotificationsRequestResult,
    updateNotificationRequestResult,
    generalCatalogInitialResult,
    downloadReportFileResult,
    addPendingExport,
} from 'Redux/actions';
import { ta } from 'date-fns/locale';

function* searchTags({ payload }) {
    const { messages } = payload;
    try {
        let data = yield call(
            clientQuery,
            `query searchTags (
                $conditions: [TagSearchInput],
                $sort: [TagSortInput],
                $limit: Int,
                $offset: Int
            ) {
                result: searchTags (conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
                    items {
                        id
                        label
                    }
                }
            }`,
            {
                limit: 100,
                offset: 0
            },
            endpoints.GRAPHQL_GENERAL,
        );
        let result = { ...data.result } || null;
        if (result) {
            if (result?.items && result?.items.length > 0) {
                result.items = [{ id: -1, label: messages['common_untagged'] }, ...result.items]
            }
            yield put(searchTagsResult(result))
        } else yield put(searchTagsResult({ error: true }))
    } catch (exc) {
        yield put(searchTagsResult({ error: true }))
        ExceptionManager(exc, 'Core/containers/General/redux/saga', 'searchTags');
    }
}

function* searchManufactuers({ payload }) {
    try {
        let data = yield call(
            clientQuery,
            `query searchManufacturers (
                $conditions: [ManufacturerSearchInput], 
                $sort: [ManufacturerSortInput], 
                $limit: Int, 
                $offset: Int
            ) {
                result: searchManufacturers (conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
                    items {
                        id
                        name
                        active
                    }
                    total
                }
            }`,
            {
                limit: 100,
                offset: 0,
                sort: [{
                    field: "name",
                    order: "ASC"
                }]
            },
            endpoints.GRAPHQL_GENERAL,
        );

        if (data.result) {
            yield put(searchManufacturersResult(data.result))
        } else yield put(searchManufacturersResult({ error: true }))
    } catch (exc) {
        yield put(searchManufacturersResult({ error: true }))
        ExceptionManager(exc, 'Core/containers/General/redux/saga', 'searchManufactuers');
    }
}

function* searchSimProviderAccounts({ payload }) {
    try {
        let data = yield call(
            clientQuery,
            `query searchSimProviderAccounts (
                $conditions: [SimProviderAccountSearchInput], 
                $sort: [SimProviderAccountSortInput], 
                $limit: Int, 
                $offset: Int
            ) {
                result: searchSimProviderAccounts (conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
                    items {
                        id
                        name
                        simProviderId
                        simProvider {
                            id
                            name
                        }
                    }
                    total
                }
            }`,
            {
                limit: 100,
                offset: 0,
                sort: [{
                    field: "name",
                    order: "ASC"
                }]
            },
            endpoints.GRAPHQL_GENERAL,
        );

        if (data.result) {
            yield put(searchSimProviderAccountsResult(data.result))
        } else yield put(searchSimProviderAccountsResult({ error: true }))

    } catch (exc) {
        yield put(searchSimProviderAccountsResult({ error: true }))
        ExceptionManager(exc, 'Core/containers/General/redux/saga', 'searchSimProviderAccounts');
    }
}

function* searchSimProviders({ payload }) {
    try {
        let data = yield call(
            clientQuery,
            `query searchSimProviders (
                $conditions: [SimProviderSearchInput], 
                $sort: [SimProviderSortInput], 
                $limit: Int, 
                $offset: Int
            ) {
                result: searchSimProviders (conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
                    items {
                        id
                        name
                    }
                    total
                }
            }`,
            {
                limit: 100,
                offset: 0,
                sort: [{
                    field: "name",
                    order: "ASC"
                }]
            },
            endpoints.GRAPHQL_GENERAL,
        );

        if (data.result) {
            yield put(searchSimProvidersResult(data.result))
        } else yield put(searchSimProvidersResult({ error: true }))
    } catch (exc) {
        yield put(searchSimProvidersResult({ error: true }))
        ExceptionManager(exc, 'Core/containers/General/redux/saga', 'searchSimProviders');
    }
}

function* searchDeviceModels({ payload }) {
    try {
        let data = yield call(
            clientQuery,
            `query searchDeviceModels (
                $conditions: [DeviceModelSearchInput], 
                $sort: [DeviceModelSortInput], 
                $limit: Int, 
                $offset: Int
            ) {
                result: searchDeviceModels (conditions: $conditions, sort: $sort, limit: $limit, offset: $offset
                ) {
                    items {
                        id
                        name
                        manufacturerId
                        product
                        unitTypeId
                    }
                    total
                }
            }`,
            {
                limit: 1000,
                offset: 0,
                sort: [{
                    field: "name",
                    order: "ASC"
                }]
            },
            endpoints.GRAPHQL_GENERAL,
        );

        if (data.result) {
            yield put(searchDeviceModelsResult(data.result))
        } else yield put(searchDeviceModelsResult({ error: true }))
    } catch (exc) {
        yield put(searchDeviceModelsResult({ error: true }))
        ExceptionManager(exc, 'Core/containers/General/redux/saga', 'searchDeviceModels');
    }
}

function* searchEntity({ payload }) {
    try {
        let key = payload.key;
        let openSearch = payload.openSearch;
        let query = "";
        let sort = [{
            field: "name",
            order: "ASC"
        }];

        switch (key) {
            case "tags":
                query = `query searchTags (
                    $conditions: [TagSearchInput],
                    $sort: [TagSortInput],
                    $limit: Int,
                    $offset: Int
                ) {
                    result: searchTags (conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
                        items {
                            id
                            label
                        }
                    }
                }`;
                sort[0].field = "label";
                break;
            case "manufacturers":
                query = `query searchManufacturers (
                    $conditions: [ManufacturerSearchInput], 
                    $sort: [ManufacturerSortInput], 
                    $limit: Int, 
                    $offset: Int
                ) {
                    result: searchManufacturers (conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
                        items {
                            id
                            name
                            active
                        }
                        total
                    }
                }`;
                break;
            case "deviceModels":
                query = `query searchDeviceModels (
                    $conditions: [DeviceModelSearchInput], 
                    $sort: [DeviceModelSortInput], 
                    $limit: Int, 
                    $offset: Int
                ) {
                    result: searchDeviceModels (conditions: $conditions, sort: $sort, limit: $limit, offset: $offset
                    ) {
                        items {
                            id
                            name
                            manufacturerId
                            product
                            unitTypeId
                        }
                        total
                    }
                }
                `;
                break;
            case "simProviderAccounts":
                query = `query searchSimProviderAccounts (
                    $conditions: [SimProviderAccountSearchInput], 
                    $sort: [SimProviderAccountSortInput], 
                    $limit: Int, 
                    $offset: Int
                ) {
                    result: searchSimProviderAccounts (conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
                        items {
                            id
                            name
                            simProviderId
                            simProvider {
                                id
                                name
                            }
                        }
                        total
                    }
                }`;
                sort[0].field = "simProvider_name";
                break;
            case "simProviders":
                query = `query searchSimProviders (
                    $conditions: [SimProviderSearchInput], 
                    $sort: [SimProviderSortInput], 
                    $limit: Int, 
                    $offset: Int
                ) {
                    result: searchSimProviders (conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
                        items {
                            id
                            name
                        }
                        total
                    }
                }`;
                break;
            case "pulsCustomers":
                query = `
                query searchCalampPulsCustomers {
                   result: searchCalampPulsCustomers
                }
                `
                break;
            case "firmwares":
                query = `query searchFirmwares (
                    $conditions: [FirmwareSearchInput], 
                    $sort: [FirmwareSortInput], $limit: Int, 
                    $offset: Int
                ) {
                    result: searchFirmwares (conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
                        items {
                            id
                            manufacturerId
                            hardwareVersion
                            firmwareId
                            version
                            isDefault
                            build
                            description
                            fileUrl
                            isActive
                            releaseTime
                        }
                        total
                    }
                }`;

                sort[0].field = "version";
                sort[0].order = "DESC";
                break;
            case "pmUsers":
                query = `
                    query searchUsers($conditions: [UserSearchInput], $sort: [UserSortInput], $limit: Int, $offset: Int) {
                        result: searchUsers( conditions: $conditions, sort: $sort, limit: $limit, offset: $offset ) {
                            items {
                                id
                                lastName
                                firstName
                                username
                            }
                            total
                        }
                    }
                `;
                sort[0].field = "username";
                sort[0].order = "ASC";
                break;
            case "unitTypes":
                query = `
                query searchUnitTypes ($conditions: [UnitTypeSearchInput], $sort: [UnitTypeSortInput], $limit: Int, $offset: Int) {
                   result: searchUnitTypes (conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
                        items {
                            id
                            name
                            manufacturerId
                            manufacturer {
                                id
                                name
                                active
                            }
                            active
                        }
                        total
                    }
                }
                `;
                break;
            case "timezones":
                query = `
                    query searchTimezones ($conditions: [TimezoneSearchInput], $sort: [TimezoneSortInput], $limit: Int, $offset: Int) {
                        result: searchTimezones (conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
                            items {
                                id
                                name
                            }
                            total
                        }
                    }
                `;
                sort[0].field = "name";
                sort[0].order = "ASC";
                break;
            case "smsIntegrations":
                query = `
                    query searchSmsIntegration ($conditions: [SmsIntegrationSearchInput], $sort: [SmsIntegrationSortInput], $limit: Int, $offset: Int) {
                        result: searchSmsIntegration (conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
                            items {
                                id
                                name
                                priority
                                isSMPP
                            }
                            total
                        }
                    }
                `;
                sort[0].field = "priority";
                sort[0].order = "ASC";
                break;
            case "dealers":
                query = `
                    query searchDealers ($conditions: [DealerSearchInput], $sort: [DealerSortInput], $limit: Int, $offset: Int) {
                        result: searchDealers (conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
                            items {
                                id
                                name
                                brandId
                                brand {
                                    id
                                    title
                                    domains
                                }
                            }
                            total
                        }
                    }
                `;
                sort[0].field = "name";
                sort[0].order = "ASC";
                break;
            case "alertTypes":
                query = `
                    query searchAlertTypes ($conditions: [AlertTypeSearchInput], $sort: [AlertTypeSortInput], $limit: Int, $offset: Int) {
                    result: searchAlertTypes (conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
                            items {
                                id
                                name
                                code
                                parentId
                            }
                            total
                        }
                    }
                `;
                sort[0].field = "name";
                sort[0].order = "ASC";
                break;
            case "ctcAccounts":
                query = `
                    query searchCalampAccounts {
                        result: searchCalampAccounts {
                            id
                            name
                        }
                    }
                `;
                break;
            case "keyFobModels":
                query = `
                    query searchKeyFobModels ($conditions: [KeyFobModelSearchInput], $sort: [KeyFobModelSortInput], $limit: Int, $offset: Int) {
                    result: searchKeyFobModels (conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
                            items {
                                id
                                name
                            }
                            total
                        }
                    }
                `;
                sort[0].field = "name";
                sort[0].order = "ASC";
                break;
            case "events":
                query = `
                    query getEvents  {
                        result: getEvents  {
                            id
                            name
                            color
                        }
                    }
                `;

                break;
            case "integrations":
                query = `
                query searchIntegrations ($conditions: [IntegrationSearchInput], $sort: [IntegrationSortInput], $limit: Int, $offset: Int) {
                   result: searchIntegrations (conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
                        items {
                            id
                            name
                            code
                            description
                        }
                        total
                    }
                }
                `;
                break;
            case "accounts":
                query = `
                    query searchCompanies ($conditions: [CompanySearchInput], $sort: [CompanySortInput], $limit: Int, $offset: Int) {
                        result: searchCompanies (conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
                            items {
                                id
                                name
                            }
                            total
                        }
                    }
                `;
                sort[0].field = "name";
                sort[0].order = "ASC";
                break;
            case "units":
                query = `
                    query searchUnits ($conditions: [UnitSearchInput], $sort: [UnitSortInput], $limit: Int, $offset: Int) {
                        result: searchUnits (conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
                            items {
                                id
                                label
                            }
                            total
                        }
                    }
                `
                sort[0].field = "label";
                sort[0].order = "ASC";
                break;
            case "brands":
                query = `
                    query searchBrands ($conditions: [BrandSearchInput], $sort: [BrandSortInput], $limit: Int, $offset: Int) {
                        result: searchBrands (conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
                            items {
                                id
                                title
                            }
                            total
                        }
                    }
                `
                sort[0].field = "title";
                sort[0].order = "ASC";
                break;
            case "sources":
                query = `
                    query searchEntityLists ($conditions: [EntityListSearchInput], $sort: [EntityListSortInput], $limit: Int, $offset: Int) {
                        result: searchEntityLists (conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
                            items {
                                id
                                label
                            }   
                        }
                    }
                `
                sort[0].field = "label";
                break;
            case "subUsers":
                query = `
                    query searchSubUsers ($conditions: [SubUserSearchInput], $sort: [SubUserSortInput], $limit: Int, $offset: Int) {
                        result: searchSubUsers (conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
                            items {
                                id
                                userName
                            }
                        }
                    }
                `;
                sort[0].field = "userName";
                sort[0].order = "ASC";
                break;
            default:
                break;
        }

        let conditions = [
            {
                "fields": [
                    "isSMPP"
                ],
                "terms": [false],
                "exact": true
            },
            {
                "fields": [
                    "active"
                ],
                "terms": [true],
                "exact": true
            }
        ]

        let filters = {
            limit: 1000,
            offset: 0,
            sort: sort
        }

        if (key === "units" || key === "accounts")
            filters.limit = 20


        if (key === "smsIntegrations") {
            filters.conditions = conditions
        }

        if (key === "accounts") {
            filters.conditions = [
                { fields: ["name"], terms: [`${openSearch}`], exact: false, conditionOperator: "OR" }
            ]
        }

        if (key === "units") {
            filters.conditions = [
                { fields: ["label"], terms: [`${openSearch}`], exact: false, conditionOperator: "OR" }
            ]
        }

        if (key === "sources") {
            filters.conditions = [
                {
                    fields: payload.fields,
                    terms: payload.terms,
                    exact: true,
                }
            ]
        }

        if (key === "subUsers" && payload?.companyId) {
            filters.conditions = [
                { fields: ["companyId"], terms: [payload.companyId], exact: true, conditionOperator: "AND" },
            ]
        }

        let data = yield call(
            clientQuery,
            query,
            filters,
            endpoints.GRAPHQL_GENERAL,
        );

        if (data.result) {
            let result = null
            if (key === "ctcAccounts" || key === "events") result = { data: data?.result, key: key };
            else result = { ...data.result, key: key }

            if (key === "tags") {

            }

            yield put(searchEntityResult(result))
        } else yield put(searchEntityResult({ error: true }))
    } catch (exc) {
        yield put(searchEntityResult({ error: true }))
        ExceptionManager(exc, 'Core/containers/General/redux/saga', 'searchEntity');
    }
}

function* searchDealers({ payload }) {
    try {
        let QUERY = `
            query searchDealers ($conditions: [DealerSearchInput], $sort: [DealerSortInput], $limit: Int, $offset: Int) {
                result: searchDealers (conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
                    items {
                        id
                        name
                        brandId
                        brand {
                            id
                            title
                            domains
                        }
                    }
                }
            }
        `;

        let data = yield call(
            clientQuery,
            QUERY,
            {
                limit: 1000,
                offset: 0
            },
            endpoints.GRAPHQL_GENERAL,
        );

        if (data?.result) {
            const { items } = data?.result;
            yield put(searchDealersResult(items))
        }

    } catch (exc) {
        console.log('exc', exc)
    }
}

function* searchTimeZones({ }) {
    try {
        let QUERY = `
            query searchTimeZones ($openSearch: String) {
                result: searchTimeZones (openSearch: $openSearch) {
                    id
                    name
                }
            }
        `;

        let data = yield call(
            clientQuery,
            QUERY,
            {
                "openSearch": ""
            },
            endpoints.PX_CLOUD_API,
        );

        if (data?.result) {
            yield put(searchTimeZonesResult(data?.result));
        } else {
            yield put(searchTimeZonesResult([]));
        }

    } catch (exc) {
        yield put(searchTimeZonesResult([]));
        console.log('exc', exc)
    }
}

function* saveAuditLogs({ payload }) {
    try {

        let { entityName, entityId, action, oldValues, newValues, updatedBy, updatedOn } = payload;

        let QUERY =
            `mutation saveAuditlog ($entityName: String!, $entityId: String!, $action: String!, $oldValues: String, $newValues: String, $updatedBy: String!, $updatedOn: AWSDateTime!) {
               result: saveAuditlog (entityName: $entityName, entityId: $entityId, action: $action, oldValues: $oldValues, newValues: $newValues, updatedBy: $updatedBy, updatedOn: $updatedOn) {
                    id
                    source
                }
            }`

        let data = yield call(
            clientMutation,
            QUERY,
            {
                entityName: entityName,
                entityId: entityId,
                action: action,
                oldValues: oldValues,
                newValues: newValues,
                updatedBy: updatedBy,
                updatedOn: moment().utc().format("YYYY-MM-DDTHH:mm:ss.sss") + "Z"
            },
            endpoints.PX_CLOUD_API,
        );

        if (data && data.result) {
            yield put(saveAuditLogResult(data.result));
        }


    } catch (exc) {

        ExceptionManager(exc, 'Core/containers/General/redux/saga', 'saveAuditLogs');
        yield put(saveAuditLogResult({ error: exc }));

    }
}

function* sendGenericExportRequest({ payload }) {
    const { type, graphqlQuery, graphqlVariables, columns, exportFormat, isPXSource, isDynamo, pxAccount, name, custom, limit  } = payload;
    let currentGraphqlVariables = graphqlVariables
    try {
        let QUERY = `
            mutation genericExport ($name: String, $sessionId: String, $type: ExportType!, $graphqlQuery: String!, $graphqlVariables: AWSJSON, $columns: [ColumnsInput]!, $exportFormat: ExporterFormatInput, $isPXSource: Boolean, $isDynamo: Boolean, $pxAccount: Int, $limit: Int) {
                result: genericExport (name:$name, sessionId: $sessionId, type: $type, graphqlQuery: $graphqlQuery, graphqlVariables: $graphqlVariables, columns: $columns, exportFormat: $exportFormat, isPXSource: $isPXSource, isDynamo: $isDynamo, pxAccount: $pxAccount, limit: $limit)
            }
        `;
        if (!isPXSource && Array.isArray(currentGraphqlVariables?.conditions) && !custom) {
            currentGraphqlVariables = {
                ...currentGraphqlVariables, conditions: currentGraphqlVariables.conditions.map((item) => ({
                    exact: item?.exact,
                    fields: item?.fields,
                    terms: item?.terms,
                    range: item?.range,
                    conditionOperator: item?.conditionOperator
                }))
            }
            currentGraphqlVariables.conditions = currentGraphqlVariables?.conditions && currentGraphqlVariables?.conditions.filter((item) => item?.fields || item?.range)
        }
        
        let data = yield call(
            clientMutation,
            QUERY,
            {
                name,
                sessionId: sessionStorage.getItem("sessionId"),
                type: type,
                graphqlQuery,
                graphqlVariables: JSON.stringify(currentGraphqlVariables || {}),
                columns,
                exportFormat,
                isPXSource,
                isDynamo,
                pxAccount,
                limit: limit
            },
            endpoints.GRAPHQL_GENERAL
        );

        // Parse the result JSON to extract the export job ID and register as pending
        try {
            const parsed = data?.result ? JSON.parse(data.result) : null;
            if (parsed?.result && parsed?.id) {
                yield put(addPendingExport({ id: parsed.id, name: name || 'export' }));
            }
        } catch (_) { /* non-blocking */ }

        yield put(genericExportResult(data?.result))

    } catch (exc) {
        yield put(genericExportResult(false))
        ExceptionManager(exc, 'Core/containers/General/redux/saga', 'sendGenericExportRequest');
    }
}

function* countPendingNotifications({ payload }) {

    try {
        let QUERY = `
            query countPendingPushNotifications {
                result: countPendingPushNotifications
            }
            `;

        let data = yield call(
            clientQuery,
            QUERY,
            {},
            endpoints.PX_CLOUD_API
        );

        yield put(searchCountNotificationsRequestResult({ count: data?.result }))
    } catch (exc) {
        yield put(searchCountNotificationsRequestResult({ error: { exc }, count: 0 }))
        ExceptionManager(exc, 'Core/containers/General/redux/saga', 'countPendingNotifications');
    }
}

function* searchNotifications({ payload }) {
    try {

        const { limit, nextToken } = payload
        let QUERY = `
        query searchNotifications ($limit: Int, $nextToken: String) {
            result: searchNotifications (limit: $limit, nextToken: $nextToken) {
                items {
                    id
                    sessionId
                    accountId
                    payload
                    createdOn
                    type
                    read
                }
                nextToken
            }
        }
    `;

        let data = yield call(
            clientQuery,
            QUERY,
            {
                limit: limit,
                nextToken: nextToken
            },
            endpoints.PX_CLOUD_API,
        );

        if (data?.result) {
            yield put(searchNotificationsRequestResult(data?.result));
        } else {
            yield put(searchNotificationsRequestResult({ items: [], nextToken: null }));
        }
    } catch (exc) {
        yield put(searchNotificationsRequestResult({ error: exc, items: [], nextToken: null }))
        ExceptionManager(exc, 'Core/containers/General/redux/saga', 'searchNotifications');
    }
}

function* updateNotification({ payload }) {
    try {

        const { id } = payload

        let QUERY = `
            mutation updateNotification ($id: String!, $read: Boolean!) {
                result: updateNotification (id: $id, read: $read)
            }
        `;

        let data = yield call(
            clientMutation,
            QUERY,
            {
                id: id,
                read: true
            },
            endpoints.PX_CLOUD_API
        );
        yield put(updateNotificationRequestResult(data?.result))
    } catch (exc) {
        yield put(updateNotificationRequestResult({ error: { exc } }))
        ExceptionManager(exc, 'Core/containers/General/redux/saga', 'updateNotification');
    }
}

function* savePreference({ payload }) {
    try {
        const { entityName, entityId, preferenceKey, preferenceValue } = payload;
        let QUERY = `
            mutation savePreference ($projectKey: ProjectKey!, $entityName: EntityName!, $entityId: String!, $preferenceKey: String!, $preferenceValue: AWSJSON!){
                result: preference: savePreference (projectKey: $projectKey, entityName: $entityName, entityId: $entityId, preferenceKey: $preferenceKey, preferenceValue: $preferenceValue) {
                    id
                }
            }
        `
        let data = yield call(
            clientMutation,
            QUERY,
            {
                projectKey: "PM",
                entityName,
                entityId,
                preferenceKey,
                preferenceValue: JSON.stringify(preferenceValue)
            },
            endpoints.PX_CLOUD_API,
        );

    } catch (exc) {
        ExceptionManager(exc, 'Core/containers/General/redux/saga', 'savePreference');
    }
}

function* getPreference({ payload }) {
    try {
        const { entityName, entityId, preferenceKey } = payload;
        let QUERY = `
            query getPreference ($projectKey: ProjectKey!, $entityName: EntityName!, $entityId: String!, $preferenceKey: String!) {
                result: getPreference (projectKey: $projectKey, entityName: $entityName, entityId: $entityId, preferenceKey: $preferenceKey) {
                    id
                    projectKey
                    entityName
                    entityId
                    preferenceKey
                    preferenceValue
                }
            }
        `;

        let data = yield call(
            clientQuery,
            QUERY,
            {
                projectKey: "PM",
                entityName,
                entityId,
                preferenceKey
            },
            endpoints.PX_CLOUD_API,
        );

    } catch (exc) {
        ExceptionManager(exc, 'Core/containers/General/redux/saga', 'getPreference');
    }
}


function* loadInitialCatalogs() {

    try {
        const data = yield call(clientQuery,
            `
				query {
					units: searchUnits( conditions:[], limit: 300, offset:0) {
                        items {
                            id
                            label
                            esn
                        }
					}

					tags: searchTagsOpen (openSearch: "", limit: 100, offset: 0, parentId: 0) {
						items {
							id
							label
							color
							disabled
                            companiesCount
							unitsCount
						}
					}

					unitTags: searchTagsAndEntities (openSearch: "", limit: 0, offset: 0, entityName: "Unit", onlyEntities: true) {
						items {
							unitId: id
							tagId: parentTagId
						}
					}
				}
				`, {}, endpoints.GRAPHQL_GENERAL);



        //console.log("loadInitialCatalogs", data);
        yield put(generalCatalogInitialResult({
            units: data?.units?.items || [],
            loadingUnits: false,
            unitTags: data.unitTags?.items || [],
            tags: data.tags?.items || [],
            loadingTags: false
        }))
    } catch (exc) {
        // catch throw
        ExceptionManager(exc, 'Core/containers/General/redux/saga', 'loadInitialCatalogs');
        //yield put(catalogInitialResult())
    }
}

function* downloadReportFile({ payload }) {
    try {
        const { id } = payload;
        const data = yield call(clientQuery,
            `
				query downloadReportFile($id: String!) {
                    result: downloadReportFile(id: $id) {
                        url
                    }
                }
			`,
            { id },
            endpoints.GRAPHQL_PX_REPORTING
        );

        yield put(downloadReportFileResult(data?.result));
    } catch (exc) {
        ExceptionManager(exc, 'Core/containers/General/redux/saga', 'downloadReportFile');
    }
}

function* watchGeneralRequests() {
    yield takeEvery(GENERAL_SEARCH_TAGS_REQUEST, searchTags);
    yield takeEvery(GENERAL_SEARCH_MANUFACTURERS_REQUEST, searchManufactuers);
    yield takeEvery(GENERAL_SEARCH_SIM_PROVIDER_ACCOUNTS_REQUEST, searchSimProviderAccounts);
    yield takeEvery(GENERAL_SEARCH_SIM_PROVIDERS_REQUEST, searchSimProviders);
    yield takeEvery(GENERAL_SEARCH_DEVICE_MODELS_REQUEST, searchDeviceModels);
    yield takeEvery(GENERAL_SEARCH_DEALERS_REQUEST, searchDealers);
    yield takeEvery(GENERAL_SEARCH_TIMEZONES_REQUEST, searchTimeZones);
    yield takeEvery(GENERAL_SEARCH_ENTITY_REQUEST, searchEntity);
    yield takeEvery(GENERAL_SAVE_AUDIT_LOG, saveAuditLogs);
    yield takeEvery(GENERAL_GENERIC_EXPORT_SEND, sendGenericExportRequest);
    yield takeEvery(GENERAL_COUNT_PEDING_NOTIFICATIONS, countPendingNotifications);
    yield takeEvery(GENERAL_SEARCH_NOTIFICATIONS, searchNotifications);
    yield takeEvery(GENERAL_UPDATE_NOTIFICATION, updateNotification);
    yield takeEvery(GENERAL_SAVE_PREFERENCE, savePreference);
    yield takeEvery(GENERAL_GET_PREFERENCE, getPreference);
    yield takeEvery(GENERAL_CATALOG_INITIAL, loadInitialCatalogs);
    yield takeEvery(GENERAL_DOWNLOAD_REPORT_FILE_REQUEST, downloadReportFile);

}

//Saga Export
export default function* rootSaga() {
    yield all([
        fork(watchGeneralRequests)
    ]);
}